/* eslint-disable prefer-template, no-unused-vars */
import React, { PropTypes } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { IME_ITEM, IME_SPACE } from 'es6/components/apps/ime';

/**
 * Wraps each typeable letter in the answer text with an element styled to look like a fill in the
 * blank input field.
 *
 * In addition, spaces have a className applied to them to make them wider than usual.
 */
export default function FillInTheBlankAnswer({ imeState = [] }) {
  const elements = imeState.map((object, index) => {
    if (object.type === IME_ITEM) {
      return object.letters.map(({ isTypeable, text }, letterIndex) => {
        const key = `${index}-${letterIndex}`;
        const className = isTypeable ? css(styles.answerFillInTheBlankLetter) : null;

        return <span key={key} className={className}>{text}</span>;
      });
    } else {
      const key = index;
      const className = object.type === IME_SPACE ? css(styles.answerLetterSpace) : null;

      return <span key={key} className={className}>{object.text}</span>;
    }
  });

  return <span>{elements}</span>;
}

FillInTheBlankAnswer.propTypes = {
  imeState: PropTypes.arrayOf(PropTypes.object),
};

export const styles = StyleSheet.create({
  answerFillInTheBlankLetter: {
    display: 'inline-block',
    borderBottom: '2px solid white',
    marginRight: '2px',
    textAlign: 'center',
    verticalAlign: 'top',
    width: '0.9em',
    height: '1.2em',
  },
  answerLetterSpace: {
    display: 'inline-block',
    width: '0.6em',
  },
});
// Pre-insert Aphrodite styles so that they are available to FitText component.
Object.keys(styles).forEach(className => css(styles[className]));
